import { createReducer } from '@reduxjs/toolkit';

import getMyProfile from '../../thunks/profile/getMyProfile';
import clearMyProfile from '../../actions/profile/getMyProfile';
import getMyPermission from '../../thunks/profile/getMyPermission';

const initialState = {
  loading: false,
  error: null,
  user: undefined,
  permissions: []
};

const getMyProfileReducer = createReducer(initialState, {
  [getMyProfile.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getMyProfile.fulfilled]: (state, { payload: user }) => ({
    ...state,
    loading: false,
    user
  }),
  [getMyProfile.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    user: undefined,
    permissions: []
  }),
  [getMyPermission.fulfilled]: (state, { payload }) => ({
    ...state,
    permissions: payload
  }),
  [clearMyProfile]: () => initialState
});

export default getMyProfileReducer;
